export default {
  selectedElementForComment: null,
  selectedEdgeForLabel: null,
}
